import { apiRequest } from "./apiClient";

export async function getUsers({ page = 1, pageSize = 10, name = null } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  if (name) {
    params.set("name", name);
  }
  return apiRequest(`/users?${params}`);
}

export async function getUser(userId) {
  return apiRequest(`/users/${userId}`);
}

export async function createUser(userData) {
  return apiRequest("/auth/create-user", {
    method: "POST",
    body: JSON.stringify(userData),
  });
}

export async function updateUser(userId, userData) {
  return apiRequest(`/users/${userId}`, {
    method: "PUT",
    body: JSON.stringify(userData),
  });
}

export async function deleteUser(userId) {
  return apiRequest(`/users/${userId}`, {
    method: "DELETE",
  });
}

export async function resetUserPassword(userId, password) {
  return apiRequest(`/users/${userId}/reset-password`, {
    method: "PUT",
    body: JSON.stringify({ password }),
  });
}
